<template>
  <div class="today-alarm" >
        <div  class="guanBoxNew" v-show="show">暂无数据</div>
        <div :id="echartId" class="guanBox" v-show="!show"  ></div>
         <!-- v-resize="resize" -->
  </div>
</template>
<script>
let vm;
import uuidv1 from "uuid/v1";
export default {
    name:'Guan',
    props:{
        pieData:
            {
                type: Array ,
                default: () => []
            },
        factorTitle:
            {
                type: String ,
                default: ''
            },
    },
    data() {
        return {
            echarts: null,
            echartId:uuidv1(),
            show:false
        };
    },
    created() {
        let vm=this
    },
    methods: {
        resize() {
            let vm = this;
            if (vm.echarts) {
                vm.echarts.resize();
            }
        },
        getPieEchart(datas) {
            let data=[datas[0]]
            let color=[]
            let vm = this
            let unit = ''
            if (vm.factorTitle == '频率偏差') {
                unit='HZ'
                color=[
                    [0.1, '#c23531'], //红色
                    [0.9, '#206ee3'], //蓝色   //0.5==0
                    [1, '#c23531'] //红色
                ]
            } else {
                unit=''
                color=[
                    [0.9, '#c23531'], //红色
                    [1, '#206ee3']  //蓝色
                ]
            }
            if (vm.echarts== null) {
                vm.echarts = vm.$echarts.init(document.getElementById(vm.echartId))
            } else {
                vm.echarts.clear()
            }
            var option = {
                tooltip: {
                formatter: '{a} <br/>{b} : {c}'+unit
                },
                toolbox: {},
                series: [
                {
                    name: data[0].name,
                    type: 'gauge',
                    data: data,
                    min: datas[1].min,
                    max: datas[1].max,
                    startAngle: 225, // 仪表盘起始角度,默认 225。圆心 正右手侧为0度，正上方为90度，正左手侧为180度。
                    endAngle: -45, // 仪表盘结束角度,默认 -45
                    axisLine: {
                    // 坐标轴线
                    // length: 30,
                    lineStyle: {
                            // 属性lineStyle控制线条样式
                            width: 8,
                            color: color
                        }
                    },
                    //仪表盘小刻度样式
                    axisTick: {
                        show: false
                    },
                    axisLabel: {
                        show: true
                    },
                    splitLine: {
                        // 分隔线
                        length: 14,
                        lineStyle: {
                            color: 'auto'
                        }
                    },
                    title: {
                        // 仪表盘标题。
                        show: true, // 是否显示标题,默认 true。
                        // offsetCenter: [0, '30%'], //相对于仪表盘中心的偏移位置，数组第一项是水平方向的偏移，第二项是垂直方向的偏移。可以是绝对的数值，也可以是相对于仪表盘半径的百分比。
                        color: '#666', // 文字的颜色,默认 #333。
                        // fontSize: 25 // 文字的字体大小,默认 15。
                    },
                    detail: {
                        // 仪表盘详情，用于显示数据。
                        // show: true, // 是否显示详情,默认 true。
                        // offsetCenter: [0, '70%'], // 相对于仪表盘中心的偏移位置，数组第一项是水平方向的偏移，第二项是垂直方向的偏移。可以是绝对的数值，也可以是相对于仪表盘半径的百分比。
                        color: 'auto', // 文字的颜色,默认 auto。
                        // fontSize: 25, // 文字的字体大小,默认 15。
                        fontSize: 25, // 文字的字体大小,默认 15。
                        formatter: '{value}' , // 格式化函数或者字符串
                    },
                    pointer: {
                        // 仪表盘指针。
                        show: true, // 是否显示指针,默认 true。 
                        length: '90%', // 指针长度，可以是绝对数值，也可以是相对于半径的百分比,默认 80%。
                        width: 4 // 指针宽度,默认 8。[[[[[[[[[[[]]]]]]]]]]]
                    }
                }
                ]
            }
            vm.echarts.setOption(option, true)
            window.addEventListener('resize', function() {
                vm.echarts.resize()
            })
        },
    },
    watch: {
        pieData:{
            handler(newVal,oldVal){
                let vm = this;
                vm.$nextTick(() => {
                    vm.getPieEchart(newVal) //频率因数
                    if(!newVal[0].value){
                        vm.show=true
                    }else{
                        vm.show=false
                    }
                })
            },
            deep:true
        }
    },
};
</script>
<style lang="scss" scoped>
.today-alarm{
    width: 100%;
    height: 100%;
   .guanBox {
        width: 100%;
        height: 100%;
    }
    .guanBoxNew{
        width: 100%;
        height: 100%;
        text-align: center;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 26px;
        color:#909399
    }
}

</style>